import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseURL } from 'src/utils/url';

/**
 * Root RTK Query API. Feature-specific endpoints are added via `baseApi.injectEndpoints`
 * (see `src/api/authApi.ts`, `src/api/consentApi.ts`) so each feature owns its endpoints
 * without coupling them through a single mega-file.
 *
 * There is no `prepareHeaders` and no Authorization header: the SSO session is an
 * HttpOnly cookie, so `credentials: 'include'` is what authenticates a request.
 * This app cannot read that cookie and must not try — see
 * `src/storage/authorize.ts`. `credentials: 'include'` also requires the API to
 * be same-origin with the page in dev, which is why requests go through the vite
 * proxy (see docs/DEV_SETUP.md).
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    credentials: 'include',
  }),
  endpoints: () => ({}),
});
